<!-- Mobile overlay -->
<div *ngIf="isMobile && visible" class="sidebar-overlay" (click)="closeSidebar()"></div>

<!-- Sidebar -->
<aside
  class="sidebar"
  [class.visible]="visible"
  [class.collapsed]="isCollapsed && !isMobile"
  [class.mobile]="isMobile"
>
  <div class="sidebar-header">
    <span class="sidebar-logo" *ngIf="!isCollapsed || isMobile">Bussify</span>
    <p-button
      *ngIf="!isMobile"
      [icon]="isCollapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"
      [text]="true"
      (onClick)="toggleCollapse()"
      severity="secondary"
      class="collapse-btn"
      [pTooltip]="isCollapsed ? 'Rozwiń' : 'Zwiń'"
      tooltipPosition="right"
    />
  </div>

  <nav class="sidebar-menu">
    <ng-container *ngFor="let item of menuItems">
      <!-- DIVIDER -->
      <p-divider *ngIf="item.type === 'divider'" class="sidebar-divider"></p-divider>

      <!-- MENU ITEM -->
      <a
        *ngIf="item.type === 'item' && item.visible && (!item.ownerOnly || isOwner())"
        [routerLink]="item.routerLink"
        [class.active]="isMenuItemActive(item)"
        class="menu-item"
        [pTooltip]="isCollapsed && !isMobile ? item.label : ''"
        tooltipPosition="right"
        (click)="onMenuItemClick()"
      >
        <i class="pi" [ngClass]="item.icon"></i>
        <span *ngIf="!isCollapsed || isMobile">
          {{ item.label }}
        </span>
      </a>
    </ng-container>
  </nav>
</aside>
